import React from 'react';
import { useComposites } from '../hooks/useComposites.ts';
import { useSurchargeLookup } from '../hooks/useSurchargeLookup.ts';
import { Spinner } from '../components/ui/spinner.tsx';
import CompositeCard from '../components/CompositeCard.tsx';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button.tsx';

const MyCompositesTab: React.FC = () => {
  const { composites, loading, error, fetchComposites } = useComposites();
  const { surcharges, loading: surchargesLoading, error: surchargesError } = useSurchargeLookup();

  if (loading || surchargesLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <Spinner size="lg" />
        <p className="ml-2 text-muted-foreground">Loading composite products...</p>
      </div>
    );
  }

  if (error || surchargesError) {
    return (
      <div className="p-4 text-center text-destructive">
        <p>Error loading data:</p>
        <p>{error || surchargesError}</p>
        <Button onClick={() => { fetchComposites(); }}>Retry</Button>
      </div>
    );
  }

  if (composites.length === 0) {
    return (
      <div className="p-4 text-center text-muted-foreground">
        <h2 className="text-2xl font-semibold mb-4">Welcome to CostWand!</h2>
        <p className="mb-4">No composite products found. Start by creating one!</p>
        <Button asChild>
          <Link to="/composites">Go to Composites Page</Link>
        </Button>
      </div>
    );
  }

  return (
    <div className="p-4">
      <h2 className="text-3xl font-bold mb-6 text-center text-secondary-foreground">Your Composite Products</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {composites.map((composite) => (
          <CompositeCard key={composite.id} composite={composite} surcharges={surcharges} />
        ))}
      </div>
    </div>
  );
};

export default MyCompositesTab;
